<template>
  <div class="card py-5 px-5">
    <b-field label="Participant">
      <b-select
        aria-disabled="true"
        disabled
        v-model="form.participant"
        expanded
      >
        <option :value="participant">{{ participant.name }}</option>
      </b-select>
    </b-field>
    <div v-if="showNewFeedbackGiverForm">
      <label class="label" for="">
        Feedback Giver
        <a @click="showNewFeedbackGiverForm = false" class="pl-2 is-size-7">
          Use Existing
        </a>
      </label>
      <div class="pl-3 border-l-2 mb-3 mt-1 form-group">
        <b-field label="First Name">
          <b-input v-model="form.feedbackGiver.first_name"></b-input>
        </b-field>
        <b-field label="Last Name">
          <b-input v-model="form.feedbackGiver.last_name"></b-input>
        </b-field>
        <b-field label="Email Name">
          <b-input v-model="form.feedbackGiver.email"></b-input>
        </b-field>
      </div>
    </div>
    <div v-else>
      <label class="label" for="">
        Feedback Giver
        <a @click="showNewFeedbackGiverForm = true" class="pl-2 is-size-7">
          New
        </a>
      </label>
      <b-field>
        <b-select v-model="form.feedbackGiver" expanded>
          <option
            v-for="feedbackGiver in feedbackGivers"
            :value="feedbackGiver"
          >
            {{ feedbackGiver.name }}
          </option>
        </b-select>
      </b-field>
    </div>

    <b-field label="Relationship">
      <b-select v-model="form.relationship" expanded>
        <option
          v-for="relationship in project.relationships"
          :value="relationship"
        >
          {{ relationship.name }}
        </option>
      </b-select>
    </b-field>
    <b-button :disabled="!canLink" type="is-primary" expanded @click="link"
      >Link</b-button
    >
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { ToastProgrammatic as Toast } from 'buefy';

const props = defineProps({
  project: Object,
  participant: Object,
});

const feedbackGivers = ref([]);

let newFeedbackGiverObject = {
  first_name: null,
  last_name: null,
  email: null,
};

fetch(
  route('users.feedbackGivers.potential', {
    user: props.participant,
    project: props.project,
  })
)
  .then((response) => response.json())
  .then((data) => {
    feedbackGivers.value = data;
  });

const form = ref({
  participant: props.participant,
  feedbackGiver: newFeedbackGiverObject,
  relationship: null,
});

const canLink = computed(() => {
  return (
    form.value.feedbackGiver.first_name &&
    form.value.feedbackGiver.last_name &&
    form.value.feedbackGiver.email &&
    form.value.relationship
  );
});

const showNewFeedbackGiverForm = ref(false);

watch(showNewFeedbackGiverForm, () => {
  form.value.feedbackGiver = newFeedbackGiverObject;
});

watch(feedbackGivers, () => {
  if (feedbackGivers.value.length === 0) {
    showNewFeedbackGiverForm.value = true;
  }
});

function link() {
  Inertia.post(
    route('users.feedbackGivers.link', {
      user: props.participant.unique_id,
      project: props.project.unique_id,
    }),
    {
      form: form.value,
    },
    {
      onError: (errors) => {
        error();
      },
      onSuccess: () => {
        if (props.errors) error();
        else success();
      },
    }
  );
}

function success() {
  form.value.feedbackGiver = newFeedbackGiverObject;
  form.value.relationship = null;
  Toast.open({
    message: 'Feedback giver added successfully',
    type: 'is-success',
    position: 'is-top',
  });
}

function error() {
  Toast.open({
    message: 'There was an error updating',
    type: 'is-danger',
    position: 'is-top',
  });
}
</script>
